const clients = {
    init() {
        clients.create();
    },
    create() {
        const clients = $("[data-client-element]");
        if (!clients.length) return;

        clients.each(function(index, el) {
            $(this).on('mouseenter', function(event) {
                $("[data-client-element]").removeClass("on");
                $(this).addClass('on');
            });
        });
    }
};

$(function() {
    clients.init();
});